import dayjs from 'dayjs';

//hooks
import useUser from '@/utils/hooks/swr/useUser';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

//lib
import userDateFormat from '@/lib/user/dateFormat';

const PeriodCell = ({ cell }) => {
    const { t } = useTranslation('reports');
    const { user } = useUser({
        revalidateOnMount: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    const { row } = cell;
    const startDate = row?.original?.start_date
        ? dayjs(row?.original?.start_date)?.format(
              userDateFormat?.[user?.settings?.date_format] ?? 'YYYY-MM-DD'
          )
        : t('general.no_start_date');
    const endDate = row?.original?.end_date
        ? dayjs(row?.original?.end_date)?.format(
              userDateFormat?.[user?.settings?.date_format] ?? 'YYYY-MM-DD'
          )
        : t('general.no_end_date');
    return (
        <div className="flex flex-col">
            <span className="mb-1 font-GMedium text-sm -tracking-wider text-icoGray-500 dark:text-icoDarkMode-wolf">
                {startDate}
            </span>
            <span className="font-GMedium text-sm -tracking-wider text-icoGray-500 dark:text-icoDarkMode-wolf">
                {endDate}
            </span>
        </div>
    );
};

PeriodCell.propTypes = {
    cell: PropTypes.object
};

export default PeriodCell;
